$(document).ready(function() {
    if (window.innerWidth < 749) { 
      //find lowest element height for product slider equal height image in mobile
     var lowestHeight = null;
        $('.product__media-item .product-media-container').each(function() {
            var height = $(this).height(); 
            
            if (lowestHeight === null || height < lowestHeight) {
                lowestHeight = height;
            }
        });
        $('.product__media-item .product-media-container').height(lowestHeight);
    }
  
    $('.tab-menu li a').on('click', function(){
  		   	var target = $(this).attr('data-rel');
  			$('.tab-menu li a').removeClass('active');
  		   	$(this).addClass('active');
  		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
  		   	return false;
    });
  
       var lastScroll = 0;  
        jQuery(window).scroll(function() {  
            let myMediaQuery = window.matchMedia('(max-width: 600px)');
            if(myMediaQuery.matches) {
              var scroll = jQuery(window).scrollTop();
               if (scroll > 1150 ) {
                    jQuery(".mobile_buy_button").addClass("stickyadd");
               } else {
                 jQuery(".mobile_buy_button").removeClass("stickyadd");
               }
            }
        });
   
    //free popup hide when outer click
   $(document).mouseup(function (e) {
        var container = $("#myPopup");
    	if (!container.is(e.target) && container.has(e.target).length === 0) {
    		$(container).addClass('hide');
    	}
  });
   
   //make swiper selected collection order first on refresh
   $('.template-collection .swiper-slide:has(.sw-item.click-active)').css('order','-1');
   
  // Hides show SubMenu.
  $(".cat_filter details, .navright .dropdown-menu ,.navright .dropdown-menu details,.navright .mega-menu details,.navright .mega-menu").hover(function() {
       $(this).prop('open', true)
    });
   
    $(".cat_filter details .header__submenu, .navright .dropdown-menu .header__submenu,.mega-menu .mega-menu__content").parent("details").mouseleave(function () {
      $(this).prop('open', false);
    });
    // $(".header_filter details .mega-menu__content").parent("details").mouseleave(function () {
    //   $(this).prop('open', false);
    // });


   //make scroll to swiper collection on refresh on collection
    if ($('.template-collection')[0]){
        var slidesgh = ($('.header-wrapper ').height() ? $('.header-wrapper ').height() : 0 ) + ($('.main-marquee').height() ? $('.main-marquee').height() : 0 ) - 40;
        var slidess = ($('.template-collection .swiper_collection')[0] ? $('.template-collection .swiper_collection').offset().top : 0 )  - slidesgh;
        setTimeout(() => {
         $(window).scrollTop(slidess);
        }, "1500");
    }
  });


if (window.innerWidth < 767) { 
      jQuery('.footer-block__heading').each(function(){
          $(this).on( "click", function() {
              jQuery(this).next('ul').slideToggle();
               jQuery(this).children('svg').toggleClass('rotate-icon');
          });
      });
  }
 $('.swiper_collection .sw-item').on( "click", function() {
    $('.swiper_collection .sw-item').removeClass('click-active');
   jQuery(this).addClass('click-active');
});

 $('.mobile_buy_button').on( "click", function() {
    $(window).scrollTop(500);
  });

$('.reviewrating.mobs .reviewratingslider').slick({
      dots: true,
      arrows: true,
      speed: 1500,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000, 
      fade: false,
      prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
      nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>",
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
            }
        }
      ]
    });
// $('.upsell').slick({
//       dots: false,
//       arrows: false,
//       speed: 1500,
//       loop: true,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       infinite: true,
//       autoplay: false,
//       autoplaySpeed: 1500,
//       fade: false,
//       prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
//       nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>"
//     });

  $('.logodiv').slick({
        dots: false,
        arrows: false,
        speed: 1500,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: false,
        prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
        nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>",
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false
              }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false
              }
          }
        ]
      });

  // pagefly template image slider 
    $('.page-fly_image_inner .pagefly-logodiv').slick({
        dots: true,
        arrows: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
      prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
        nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>",
    responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
          },          
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
              }
          }
        ]
      });

 

$(document).on('click', '.close.toggle', function(event) {
   $('cart-drawer').addClass('active');
   $('body').addClass('overflow-hidden');
}); 

$(document).on('click', '.header__icon.header__icon--cart', function(event) {
   $('cart-drawer').addClass('active');
   $('body').addClass('overflow-hidden');
});

 $(document).on('click', '#myPopup .custom_buy', function(event) {
   $('.close.toggle').trigger('click');
});

$(document).on('click', '.toggle', function(event) {
  event.preventDefault();
  var target = $(this).data('target');
  $('#' + target).toggleClass('hide');
});

jQuery(window).on('load resize', function () {
  
  let free_product_mediascreen = window.matchMedia('(max-width: 767px)');
  // if (free_product_mediascreen.matches &&  $('.free_product_popup'))  {
  //     $('.free_product_popup').slick({
  //         dots: true,
  //         arrows: false,
  //         speed: 1500,
  //         loop: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         autoplay: true,
  //         autoplaySpeed: 1500,
  //         fade: false,
  //         prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
  //         nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>"
  //       });
  //   } 


          let myMediaQuery = window.matchMedia('(min-width: 320px)');
          if(myMediaQuery.matches) {
              var text = [".template-search .product-grid-container .card__inner",".template-search .product-grid-container .card__inner media",".template-search .product-grid-container .card__inner media img"];
              text.forEach(function(data){
                 compwidth = $(data).innerWidth();
                 compheight = $(data).height(compwidth); 
                 $(data).css('height', compheight+'px !important');
                //console.log(compwidth);
              });
  
            var text = [".swiper_collection .sw-item",".reviewratingcont .sect","#CartDrawer .main_upsell","#myPopup .main_upsell",".free_product_popup .upsell_title"];
            
            text.forEach(function(data){
            function getTallestHeaderHeight(ele) {
  				var maxHeight = 0;
                jQuery(ele).each(function() {
                    if (jQuery(this).height() > maxHeight)
                        maxHeight = jQuery(this).height();
                })
                return maxHeight;
            }
            jQuery(data).height('auto');
            jQuery(data).height(getTallestHeaderHeight(data))
            jQuery(data).css('min-height',  getTallestHeaderHeight(data) + '!Important;' );
        });
	}
    
}).resize();